<style scoped lang="scss">
    .tournament-list-wrap{background: #f4f9ff; margin-top: 9px;
        .tournament-list{

        }
        .tournament-list:last-child{
            border: none;
        }
    }
    .tournament-list-wrap.empty-team-list{
        padding: 10px 14px;
        >p{
            font-size: 1.4rem;
            background: #ffffff;
            padding: 15px;
        }
    }

</style>

<template>
    <div class="tournament-list-wrap" v-if="matchList.length > 0 && !loadingCheck">
        <div class="tournament-list" v-for="(match, matchIndex) in matchList" :key="`subMatch ${matchIndex}`">
            <div class="tournament-top-info-wrap">
                <p class="left-wrap">
                    <span class="gym-name">{{match.gameName}}</span>
                </p>
            </div>
            <div v-if="match.isPlaying==='D'">
                <div class="tournament-wrap">
                    <div class="thumbnail" :style="{backgroundImage: `url('${match.thumbnail}')`}" @click="urlBroadCastFunc(match)">
                        <div class="play-btn" v-if="match.broadcastUrl"></div>
                    </div>
                    <!--경기완료-->
                    <div class="tournament-info-wrap">
                        <table>
                            <tr :class="match.winnerParticipantId === match.firstParticipantId ? 'win' : 'lose'">
                                <td class="player-info-wrap">
                                    <div class="player-info">
                                        <p class="team">{{match.firstParticipantName}}</p>
                                        <p class="player">
                                            <span v-if="(match.isOpponentRetired === 'W' || match.isOpponentRetired === 'A') && match.winnerParticipantId === match.firstParticipantId" class="label is-opponent-retired ">기권승</span>
                                            <span v-else-if="(match.isOpponentRetired === 'W' || match.isOpponentRetired === 'A') && match.winnerParticipantId !== match.firstParticipantId" class="label is-opponent-retired ">기권패</span>
                                            <span
                                                    v-else-if="match.winnerParticipantId === match.firstParticipantId"
                                                    class="label">승</span>
                                            <span class="label" v-else>패</span>
                                            <span class="player-name"><span
                                                    v-for="user in match.firstParticipantTeamList">{{user.playerName}} </span></span>
                                        </p>
                                    </div>
                                </td>
                                <td class="score-wrap">
                                    <div class="score-content">
                                        <p v-for="(score, scoreIndex) in match.setScoreList" :key="`score ${scoreIndex}`"
                                           :class="score.firstParticipantGame > score.secondParticipantGame ?  'win' : 'lose'">
                                            {{score.firstParticipantGame}}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr :class="match.winnerParticipantId === match.secondParticipantId ? 'win' : 'lose'">
                                <td class="player-info-wrap">
                                    <div class="player-info">
                                        <p class="team">{{match.secondParticipantName}}</p>
                                        <p class="player">
                                            <span v-if="(match.isOpponentRetired === 'W' || match.isOpponentRetired === 'A') && match.winnerParticipantId === match.secondParticipantId" class="label is-opponent-retired ">기권승</span>
                                            <span v-else-if="(match.isOpponentRetired === 'W' || match.isOpponentRetired === 'A') && match.winnerParticipantId !== match.secondParticipantId" class="label is-opponent-retired ">기권패</span>
                                            <span class="label" v-else-if="match.winnerParticipantId === match.secondParticipantId">승</span>
                                            <span class="label" v-else>패</span>
                                            <span class="player-name"><span v-for="user in match.secondParticipantTeamList">{{user.playerName}} </span></span>
                                        </p>
                                    </div>
                                </td>
                                <td class="score-wrap">
                                    <div class="score-content">
                                        <p v-for="(score, scoreIndex) in match.setScoreList" :key="`score ${scoreIndex}`"
                                           :class="score.firstParticipantGame < score.secondParticipantGame ?  'win' : 'lose'">
                                            {{score.secondParticipantGame}}</p>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="tournament-schedule-wrap" v-else>
                <div class="player-info-wrap">
                    <div class="player-info">
                        <p class="participant-name">{{match.firstParticipantName}}</p>
                        <span class="player-name"><span v-for="user in match.firstParticipantTeamList">{{user.playerName}} </span></span>
                    </div>
                    <p v-if="match_parent.isPlaying  === 'D'">경기완료</p>
                    <p v-else>경기예정</p>
                </div>
                <div class="player-info-wrap">
                    <div class="player-info">
                        <p class="participant-name">{{match.secondParticipantName}}</p>
                        <span class="player-name"><span v-for="user in match.secondParticipantTeamList">{{user.playerName}} </span></span>
                    </div>
                    <p v-if="match_parent.isPlaying  === 'D'">경기완료</p>
                    <p v-else>경기예정</p>
                </div>
            </div>
        </div>
    </div>
    <div class="tournament-list-wrap empty-team-list" v-else-if="matchList.length ===0 && !loadingCheck">
        <p>아직 대진이 완성되지 않았습니다</p>
    </div>
    <div v-else></div>
</template>
<script>
    export default{
        props: ['match_parent'],
        data(){
            return{
                matchList: [],
                loadingCheck:false
            }
        },
        methods:{

            getDate(date) {
                const year = date.substr(0, 4)
                const month = date.substr(4, 2)
                const day = date.substr(6, 2)

                const week = ['일', '월', '화', '수', '목', '금', '토', '일']

                const datetime = new Date(`${year}-${month}-${day}`)

                return `${month}.${day} ${week[datetime.getDay()]}`
            },
            getTime(time) {
                const hour = time.substr(0, 2)
                const min = time.substr(2, 2)

                return `${hour}:${min}`
            },
            urlBroadCastFunc(match){
                if(match.broadcastUrl){
                    window.open(match.broadcastUrl)
                }
            }
        },
        created() {
            const tnmtId = this.$route.params.tnmtId
            const matchId = this.match_parent.matchId
            const _this  = this
            _this.loadingCheck = true
            this.$store.dispatch('tournaments/getListSubMatchResult', {tnmtId: tnmtId, matchId: matchId}).then(res => {
                // console.dir(res)
                _this.loadingCheck = false
                _this.matchList = res
            }).catch(err => {
                console.dir(err)
            })
        }
    }
</script>